import { render, staticRenderFns } from "./distribution_list.vue?vue&type=template&id=97b7f682&scoped=true"
import script from "./distribution_list.vue?vue&type=script&lang=ts"
export * from "./distribution_list.vue?vue&type=script&lang=ts"
import style0 from "./distribution_list.vue?vue&type=style&index=0&id=97b7f682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b7f682",
  null
  
)

export default component.exports